module.exports = __webpack_public_path__ + "static/media/existingClarity.39b0a4d3.svg";